var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactUs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 24.1579L31.5198 17.8421H14.0657C13.4044 17.8421 12.7702 17.6203 12.3026 17.2255C11.835 16.8307 11.5723 16.2952 11.5723 15.7368V3.10526C11.5723 2.54691 11.835 2.01143 12.3026 1.61662C12.7702 1.2218 13.4044 1 14.0657 1H36.5066C37.1679 1 37.8022 1.2218 38.2698 1.61662C38.7374 2.01143 39.0001 2.54691 39.0001 3.10526V24.1579Z",
    stroke: "#0C6CDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4278 20.3684V24.5789C28.4278 25.1373 28.1651 25.6728 27.6975 26.0676C27.2299 26.4624 26.5957 26.6842 25.9344 26.6842H8.48031L1 33V11.9474C1 11.389 1.2627 10.8535 1.73031 10.4587C2.19792 10.0639 2.83214 9.8421 3.49344 9.8421H8.48031",
    stroke: "#0C6CDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUs);
export default __webpack_public_path__ + "static/media/Icon_Contact_Us.26d04e1e1325d9dcd3808cc8461fa81a.svg";
export { ForwardRef as ReactComponent };